import img1 from "../../assets/servicesCards/brunette.webp";
import img2 from "../../assets/servicesCards/car-buyer.webp";
import img3 from "../../assets/servicesCards/pexels-helena.webp";
import img4 from "../../assets/servicesCards/male-with-mask.webp";

const services = [
	{
		id: 1,
		title: "Reservación Calendarizada",
		description:
			"Brindamos servicios de renta de autos de manera calendarizada, ya sea por día, semana o mes.",
		img: img1,
	},
	{
		id: 2,
		title: "Alquileres de larga duración",
		description:
			"Atendemos tu solicitud con autos económicos, autos de lujo y Vans para el transporte ejecutivo, recreativo, particular o de personal.",
		img: img2,
	},
	{
		id: 3,
		title: "Traslado de Grupos",
		description:
			"Contamos con el servicio de traslado de grupos con el cual brindamos un servicio de atención de calidad a todos los miembros de su comité.",
		img: img3,
	},
	{
		id: 4,
		title: "Servicio de Chofer",
		description:
			"Nuestro personal altamente calificado brinda un traslado seguro en tiempo y forma comprometido en ofrecer un viaje de calidad.",
		img: img4,
	},
];

export default function ServicesCards() {
	return (
		<div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4">
			{services.map((service, index) => (
				<div
					key={service.id}
					className="grid grid-cols-2 min-h-[250px] shadow-xl hover:shadow-2xl transition duration-300"
				>
					<div className="w-full h-full">
						<img
							src={service.img}
							alt={`Imgaen para ${service.title}`}
							className="w-full h-full object-cover"
						/>
					</div>
					<div className="bg-[#112d56] p-5 text-start flex flex-col justify-center">
						<h2 className="text-2xl font-bold text-white pb-3 sm:pb-5">
							{service.title}
						</h2>
						<p className="text-sm text-white/70">{service.description}</p>
					</div>
				</div>
			))}
		</div>
	);
}
